import React, { useState } from "react";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import ContactSummary from "./ContactSummary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { getModuleNamingBySlug } from "../../../lib/Misc";
import { useOrganization } from "../../../lib/context/OrganisationContext";

const ContactStatementAction = ({ contactId, trustId, contact }) => {
  const [showStatement, setShowStatement] = useState(null);
  const { organizationData } = useOrganization();

  const toggleStatement = () => {
    setShowStatement(!showStatement);
  };
  return (
    <>
      <span style={{ whiteSpace: "nowrap" }}>
        <FontAwesomeIcon
          title="View Statement"
          onClick={toggleStatement}
          icon={faEye}
          size="1x"
        />
      </span>
      <ResponsiveDrawerForm
        description={""}
        title={`${getModuleNamingBySlug(
          organizationData?.organizationData,
          "contacts",
          "Customer"
        )} Statment`}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"md:w-[90vw]"}
        open={showStatement}
        buttonClassName={""}
        setOpen={setShowStatement}
        read={true}
        popupType={"reports"}
      >
        <ContactSummary id={contactId} trustId={trustId} contact={contact} />
      </ResponsiveDrawerForm>
    </>
  );
};

export default ContactStatementAction;
